/* eslint-disable no-mixed-operators */
import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
import Lock from "@mui/icons-material/Lock";
import { Typography } from "@mui/material";

const RADIUS = 35;
const STROKE = 3.5;

const TaskListItemLock = ({ classes, t, onTransitionComplete }) => {
    const [progress, setProgress] = React.useState(0);
    const [mounted, setMounted] = React.useState(0);

    const normalizedRadius = RADIUS - STROKE * 2;

    const circumference = normalizedRadius * 2 * Math.PI;

    const strokeDashoffset = circumference - (progress / 100) * circumference;

    React.useEffect(() => {
        setProgress(100);
        setMounted(true);
    }, []);

    return (
        <span className={`${classes.container} ${mounted ? classes.animate : ""}`}>
            <Typography className={classes.claimedBy}> {t("Claimed by another Ambassador")} </Typography>
            <span className={classes.alignment}>
                <svg height={RADIUS * 2} width={RADIUS * 2}>
                    <circle
                        style={{ strokeDashoffset }}
                        className={classes.circle}
                        onTransitionEnd={onTransitionComplete}
                        fill="white"
                        strokeWidth={STROKE}
                        strokeDasharray={`${circumference} ${circumference}`}
                        r={normalizedRadius}
                        cx={RADIUS}
                        cy={RADIUS}
                    />
                </svg>
            </span>
            <span className={classes.alignment}>
                <Lock className={classes.lock} />
            </span>
        </span>
    );
};
const styles = theme => ({
    container: {
        position: "absolute",
        top: 0,
        display: "flex",
        width: "100%",
        height: 95,
        backgroundColor: "rgba(255, 255, 255, .7)",
        justifyContent: "center",
        alignItems: "center",
        opacity: 0.01
    },
    animate: {
        transition: "opacity 600ms",
        opacity: 1
    },
    lock: {
        fontSize: "28px",
        color: theme.palette.contrast.text
    },
    alignment: {
        position: "absolute"
    },
    circle: {
        transform: "rotate(-90deg)",
        transformOrigin: "50% 50%",
        stroke: theme.palette.primary.main,
        transition: "stroke-dashoffset 2s"
    },
    claimedBy: {
        fontSize: "11px",
        color: theme.palette.contrast.text,
        marginTop: "80px"
    }
});

export default withStyles(styles)(TaskListItemLock);
TaskListItemLock.propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    onTransitionComplete: PropTypes.func
};
